import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-abvv-maintenance',
    standalone: true,
    templateUrl: './maintenance.component.html',
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
